var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-color-bar"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:step.value,staticClass:"category-color-bar__color",class:{
      'is-active': _vm.activeStep === index,
      'is-checked': _vm.isStepChecked(step),
    },style:(("--stepColor: #" + (step.color)))})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }